import React from 'react';
import { AppBar, Box, Container, Divider, Grid, List, ListItem, Toolbar, Typography } from "@material-ui/core";
import { HashLink as Link } from 'react-router-hash-link';
import { useStyles } from "./main-styles";
import logo from "../../assets/miet-healthcare-inc.png";
import whitelogo from "../../assets/whitelogo.jpg";
import {
    routes,
    adminAuthRoutes,
    clientAuthRoutes,
    clinicianAuthRoutes,
    footerRoutes,
    patientAuthRoutes,
    patientRoutes,
    clientRoutes,
    clinicianRoutes,
    adminRoutes
} from '../../utils/routes';
import { getJWTToken, getUserRole, getUserData } from "store/selectors/userSelector";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { logoutThunk } from "store/thunks/user";
import { Avatar, Drawer, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { stringToColor } from "utils";

export function LayoutExternal({ footer, component }: any) {
    const [navRoutes, setNavRoutes] = useState(routes);
    const [navProtectedRoutes, setNavProtectedRoutes] = useState([] as any);
    const token = useSelector(getJWTToken);
    const role = useSelector(getUserRole);
    const userData = useSelector(getUserData);
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
    const drawerWidth = 240;

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        if (token) {
            switch (role.toUpperCase()) {
                case "ADMIN":
                    setNavRoutes(adminRoutes);
                    setNavProtectedRoutes(adminAuthRoutes)
                    break;
                case "CLIENT":
                    setNavRoutes(clientRoutes);
                    setNavProtectedRoutes(clientAuthRoutes)
                    break;
                case "CLINICIAN":
                    setNavRoutes(clinicianRoutes);
                    setNavProtectedRoutes(clinicianAuthRoutes)
                    break;
                case "PATIENT":
                    setNavRoutes(patientRoutes);
                    setNavProtectedRoutes(patientAuthRoutes)
                    break;
                default:
                    break;
            }

        } else {
            setNavRoutes(routes);
        }
    }, [role, token]);

    const dispatchLogout = () => {
        dispatch(logoutThunk(token, history));
    }
    const drawer = () => (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Divider key="drawerDiv" />
            <List style={{ marginTop: 127 }}>
                {navRoutes.map((item, index) => (<>
                    <ListItem key={index}>
                        <Link
                            to={`/${item.route}`}
                            className={classes.item}
                            key={`${item.text}${index}`}
                        >
                            {item.text}
                        </Link>
                    </ListItem>
                </>
                ))}
                {token && <ListItem onClick={() => dispatchLogout()}>
                    <Box
                        className={classes.item}
                    >
                        Logout
                    </Box>
                </ListItem>}
            </List>
        </Box>
    );
    const container = window.document.body;
    function stringAvatar(name: string) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }
    return (
        <Box className={classes.root}>
            <Box className={classes.appFrame}>
                <AppBar className={classes.appBar} component="nav">
                    <Container>
                        <Toolbar className={classes.toolbar}>
                            <IconButton
                                color="primary"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ mr: 2, display: { md: 'none' } }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Link to={'/'}>
                                <img src={logo} alt="logo" className={classes.logo} title="Mommyvue" />
                            </Link>
                            <Box className={classes.menuButtons}>
                                {navRoutes.map((item, index) => {
                                    return (
                                        <Link
                                            to={`/${item.route}`}
                                            className={classes.item}
                                            key={`${item.text}${index}`}
                                        >
                                            {item.text}
                                        </Link>)
                                })}
                                {/* {token ?
                                    <div
                                        className={classes.item}
                                        onClick={() => dispatchLogout()}>
                                        Logout
                                    </div> : null} */}
                            </Box>
                            {token && <Box sx={{ flexGrow: 0 }}>
                                <Tooltip title="Accessibilty Links">
                                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                        <Avatar {...stringAvatar(`${userData?.firstName} ${userData?.lastName}`)} alt={`${userData?.firstName} ${userData?.lastName}`} src="Avatar.jpg" />
                                    </IconButton>
                                </Tooltip>
                                <Menu
                                    sx={{ mt: '45px' }}
                                    id="menu-appbar"
                                    anchorEl={anchorElUser}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorElUser)}
                                    onClose={handleCloseUserMenu}
                                >
                                    {navProtectedRoutes.map((setting: any, index: number) => (
                                        <MenuItem key={`${setting.route}${index}`} onClick={() => { handleCloseUserMenu(); history.push(setting.route); }}>
                                            <Typography>{setting.text}</Typography>
                                        </MenuItem>
                                    ))}
                                    <MenuItem key={"logOut"} onClick={() => { handleCloseUserMenu(); dispatchLogout(); }}>
                                        <Typography>Logout</Typography>
                                    </MenuItem>
                                </Menu>
                            </Box>}
                        </Toolbar>
                    </Container>
                </AppBar>
                <Box component="nav">
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            display: { xs: 'block', md: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                    >
                        {drawer()}
                    </Drawer>
                </Box>
                <Box className={classes.content}>
                    {component}
                    {footer && <Footer />}
                </Box>
            </Box>
        </Box>
    );
}
export default function Footer() {
    const classes = useStyles();

    return (
        <AppBar position="sticky" color="primary" style={{ background: "#0055a5" }}>
            <Grid container item xs={8} style={{ margin: '0 auto', paddingTop: '25px' }}>
                <Grid item xs={12} style={{ marginBottom: '15px' }}>
                    <img src={whitelogo} alt="logo" className={classes.logo} title="Mommyvue" />
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "18px",
                        lineHeight: "35px",
                        width: '400px',
                    }}>
                        Contact
                    </Typography>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "14px",
                        lineHeight: "20px",
                        width: '400px',
                    }}>
                        contact@mommyvue.com
                    </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "18px",
                        lineHeight: "35px",
                        width: '400px',
                    }}>
                        Address
                    </Typography>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "14px",
                        lineHeight: "20px",
                        width: '400px',
                    }}>
                        1822 N Main St, <br />
                        Fall River, MA 02720 <br />
                        USA
                    </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "18px",
                        lineHeight: "35px",
                        width: '400px',
                    }}>
                        Customer Support
                    </Typography>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "14px",
                        lineHeight: "20px",
                        width: '400px',
                    }}>
                        support@mommyvue.com <br />
                        MommyVue Help Center
                    </Typography>
                </Grid>
                <Grid item xs={12} md={3} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'right',
                    marginTop: '60px'
                }}>
                    {footerRoutes.map((item, index) => {
                        return (<Link
                            to={`/${item.route}`}
                            key={`${item.text}${index}`}
                            style={{
                                color: 'white',
                                fontSize: "12px",
                                lineHeight: "20px"
                            }}
                        >
                            {item.text}
                        </Link>)
                    })}
                </Grid>
                <Grid item xs={12}>
                    <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                        color: "white",
                        fontSize: "14px",
                        lineHeight: "50px",
                        width: '400px',
                    }}>
                        Copyright MommyVue {new Date().getFullYear()}
                    </Typography>
                </Grid>
            </Grid>
        </AppBar>
    )
}